import { Insta } from "../../src/components/insta/InstaClass";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import UI from "../../src/shell/UI";
import { jump } from "../../src/shell/jump";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { joe } from '../characters/Joe';
import { mc } from "../characters/MC";
import { empty } from "../characters/empty";
import { globals } from '../characters/globals';
import { getInstaData } from "../helpers/InstaPostsHelpers";
import { annProfilesPic } from "../helpers/annInstaImages";
import { doPhoneRing, doTransition, doWaitImageByTime, isAnnGF, isAnnHate, isJoeEnemy } from "../helpers/helpers";
import { V7AlexAnnMC } from './V7_AlexAnnMC';
import { V7AlexMoving } from "./V7_AlexMoving";
import { V7AnnAudition } from "./V7_AnnAudition";
import { V7AnnChrisMCMovies } from "./V7_AnnChrisMcMovies";
import { V7AnnDirectorHotel } from "./V7_AnnDirectorHotel";
import { V7AnnHouse } from './V7_AnnHouse';
import { V7AnnPhotoShoot } from "./V7_AnnPhotoShoot";
import { V7AnnPureOrHate } from './V7_AnnPureMorningConv';
import { V7EmilyCarWash } from "./V7_EmilyCarWash";
import { V7EmilyConversation } from "./V7_EmilyConversation";
import { V7EmilyPhone } from "./V7_EmilyPhone";
import { V7EmilyWakeUp } from './V7_EmilyWakeUp';
import { V7JennyDate } from "./V7_JennyDate";
import { V7_JennyJoeRivalBar } from './V7_JennyJoeRivalBar';
import { V7JoeGym } from './V7_JoeyGym';
import { V7PCLadyConv } from './V7_PCLady';
import { V7AnnPreAudition } from "./V7_PreAudition";
import { V7ReturningOutfit } from './V7_ReturningOutfit';
import { V7EmilyShower } from "./V7_V7EmilyShower";
import { V7VanessaCoffeeNight } from "./V7_VanessaCoffeeNight";
import { V7VanessaOutsideConv } from './V7_VanessaConv';
import { V7VanessaMorning } from "./V7_VanessaMorning";
import { V8Start } from './V8';
import { extras, images, uiImages } from "./images";

export const V7Start = async (): Promise<any> => {

    // ImageClass.setImage(images.v2_5.BlackScreen);
    // mc.think(`You are about to start playing the recent alpha content!\nPlease save your game now and load it from this point once the version is completed to avoid bugs and unwanted behavior.`);



    if (ann.properties.isCorrupted && isAnnGF() && !Game.seenScenarios.includes(`V6VanessaCustomerMeeting`)) {

        await ann.set((properties) => {
            properties.hasInsta = true;
        });
        return jump(V7AnnPhotoShootBefore, "V7AnnPhotoShootBefore");
    }
    return jump(V7EmilyWakeUpBefore, "V7EmilyWakeUpBefore");
};
export const V7EmilyWakeUpBefore = async (): Promise<any> => {

    return jump(V7EmilyWakeUp, "V7EmilyWakeUp");
};
export const V7EmilyWakeUpAfter = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6VanessaCustomerMeeting`)) {
        return jump(V7VanessaMorningBefore, "V7VanessaMorningBefore");

    }
    return jump(V7AnnPureOrHateBefore, "V7AnnPureOrHateBefore");
};
export const V7AnnPureOrHateBefore = async (): Promise<any> => {

    return jump(V7AnnPureOrHate, "V7AnnPureOrHate");
};
export const V7AnnPureOrHateAfter = async (): Promise<any> => {
    doTransition(images.v7.V7MCRoomMorning1);
    mc.think(`It's been a slow day... Nothing interesting happened...`);
    mc.think(`I think I got used to all the weird shit that kept happening...`);
    mc.think(`But then again, sitting in front of the computer doing nothing was my normal routine not long ago.`);

    return jump(V7EmilyCarWashBefore, "V7EmilyCarWashBefore");

};

export const V7VanessaMorningBefore = async (): Promise<any> => {
    return jump(V7VanessaMorning, "V7VanessaMorning");
};
export const V7VanessaMorningAfter = async (): Promise<any> => {
    if (isAnnGF() && ann.properties.isCorrupted) {
        await Phone.showMessagesUI({ name: ann.name }, async () => {
            Phone.setMessage({ character: ann.character, text: `Hey ${mc.name}! I'm outside your house, can you let me in?`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `Of course, I'll be right there!` });
            Phone.setMessage({ character: ann.character, text: `Great! I'm waiting 😘` });
            Phone.closeMessagesUI();
        });
        return jump(V7AnnPhotoShootBefore, "V7AnnPhotoShootBefore");

    }

    return jump(V7EmilyCarWashBefore, "V7EmilyCarWashBefore");
};

export const V7EmilyCarWashBefore = async (): Promise<any> => {

    return jump(V7EmilyCarWash, "V7EmilyCarWash");
};
export const V7EmilyCarWashAfter = async (): Promise<any> => {

    return jump(V7AlexMovingBefore, "V7AlexMovingBefore");
};

export const V7AlexMovingBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v7.EmilyCarWash_15_2, { duration: 1.5, wait: 1.5, hideText: true });
    mc.think(`Let's see about this new neighbor Emily is talking about.`);

    return jump(V7AlexMoving, "V7AlexMoving");
};
export const V7AlexMovingAfter = async (): Promise<any> => {

    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1.2, wait: 1.2, hideText: true });
    ImageClass.setImage(images.v6.EmilyRoom_4, { duration: 1, wait: 1 });

    mc.talk(`Emily, you wouldn't believe who the new neighbor is--`);
    mc.think(`She is not here.`);


    return jump(V7EmilyPhoneBefore, "V7EmilyPhoneBefore");
};
export const V7EmilyPhoneBefore = async (): Promise<any> => {

    return jump(V7EmilyPhone, "V7EmilyPhone");
};
export const V7EmilyPhoneAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyRoom_4, { duration: 1 });

    return jump(V7EmilyShowerBefore, "V7EmilyShowerBefore");

};

export const V7EmilyShowerBefore = async (): Promise<any> => {

    return jump(V7EmilyShower, "V7EmilyShower");
};
export const V7EmilyShowerAfter = async (): Promise<any> => {
    return jump(V7MCRoomWait, "V7MCRoomWait");

};
export const V7EmilyConversationBefore = async (): Promise<any> => {
    emily.talk(`${mc.name}!`, { method: "Shouting" });
    mc.think(`Hmmm... Wonder why Emily is calling me...`);

    return jump(V7EmilyConversation, "V7EmilyConversation");
};
export const V7EmilyConversationAfter = async (): Promise<any> => {


    if (mc.properties.hasJennysNumber && !mc.properties.v7WentWithJennyDate) {
        ImageClass.setImage(images.v7.V7MCRoomMorning1, { duration: 1, wait: 1, hideText: true });
        mc.think(`Emily has such a good soul...`);
    }
    return jump(V7MCRoomWait, "V7MCRoomWait");


};

export const V7AnnPhotoShootBefore = async (): Promise<any> => {


    return jump(V7AnnPhotoShoot, "V7AnnPhotoShoot");
};

export const V7AnnPhotoShootAfter = async (): Promise<any> => {
    // ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true });
    // if (Question.globalAnswers.v7PhotoShootOutsideAgreedGoingMoviesAnnChris) {
    //     mc.think(`I guess I'm going to the movies later. I'll just have to wait for Ann's call.`);

    // } else if (Question.globalAnswers.v7PhotoShootOutsideAgreedGoingMoviesAnnChris === false) {
    //     mc.think(`Who wants to go to a boring ass movie anyway? Chris can have the pleasure of seeing it.`);

    // }
    // if (mc.properties.v7AnnChrisMovieStatus === "wasntInvited") {
    //     mc.think(`It was obvious he wouldn't get a ticket for me.`);
    //     mc.think(`But fuck it! Who cares about that anyway?`);
    // }
    // if (!Game.seenScenarios.includes(`V7AnnPhotoShootAfter`)) {

    //     await ann.set((properties) => {
    //         properties.instaFollowers += 582;
    //     });

    // } 

    // return jump(V7MCRoomWait, "V7MCRoomWait");
    return jump(V7EmilyCarWashBefore, "V7EmilyCarWashBefore");
};
export const V7ReturningOutfitBefore = async (): Promise<any> => {

    return jump(V7ReturningOutfit, "V7ReturningOutfit");
};
export const V7ReturningOutfitAfter = async (): Promise<any> => {
    // if (Game.seenScenarios.includes(`V7AnnPureOrHate`)) {
    //     return jump(V7AlexAnnMCAfterBefore, "V7AlexAnnMCAfterBefore");
    // }
    // return jump(V7EndDay, "V7EndDay");

    return jump(V7AlexAnnMCAfterBefore, "V7AlexAnnMCAfterBefore");
};

export const V7MCRoomWait = async (): Promise<any> => {
    if (mc.properties.v7AnnChrisMovieStatus === "went") {
        ImageClass.setImage(images.v5.Room2_2);

    } else {
        ImageClass.setImage(images.v7.V7MCRoomMorning1);

    }
    if (!Game.seenScenarios.includes(`V7MCRoomWait`)) {
        if (ann.properties.isCorrupted || mc.properties.annStatus === "hate") {
            await ann.set((properties) => {
                properties.instaFollowing = 300;
                properties.instaFollowers = 1523;
            });
        } else {

        }
    }



    await UI.add({
        key: "v7StartButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Continue", key: "continue" }
            ]
    });
    if (UI._globalUI.v7StartButtons === "insta") {

        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v7StartButtons === "continue") {

        if (!Game.seenScenarios.includes(`V7EmilyConversationBefore`)) {
            return jump(V7EmilyConversationBefore, "V7EmilyConversationBefore");
        }

        if (mc.properties.v7AnnChrisMovieStatus !== "went" && Question.globalAnswers.v7PhotoShootOutsideAgreedGoingMoviesAnnChris) {

            return jump(V7AnnChrisMCMoviesBefore, "V7AnnChrisMCMoviesBefore");
        } else {

        }

        if (mc.properties.hasJennysNumber && !mc.properties.v7WentWithJennyDate) {

            return jump(V7JennyDateBefore, "V7JennyDateBefore");
        }
        if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
            return jump(V7VanessaCoffeeNightBefore, "V7VanessaCoffeeNightBefore");

        }

        return jump(V7EndDay1, "V7EndDay1");

    }
    return jump(V7MCRoomWait, "V7MCRoomWait");


};


export const V7AnnChrisMCMoviesBefore = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7RoomNight, { duration: 1.5, wait: 1.5 });
    mc.think(`Time to go to the movies.`);

    return jump(V7AnnChrisMCMovies, "V7AnnChrisMCMovies");
};

export const V7AnnChrisMCMoviesAfter = async (): Promise<any> => {

    return jump(V7MCRoomWait, "V7MCRoomWait");
};

export const V7JennyDateBefore = async (): Promise<any> => {

    if (Question.globalAnswers.v1WentToTheBarWith !== "vanessa" && mc.properties.annStatus !== "hate") {
        ImageClass.setImage(images.v5.Room2_2);
        mc.think(`It's late. Time to sleep.`);

    } else {
        ImageClass.setImage(images.v7.V7RoomNight, { duration: 1.5, wait: 1.5 });

    }

    return jump(V7JennyDate, "V7JennyDate");

};

export const V7JennyDateAfter = async (): Promise<any> => {
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {

        doTransition(images.v7.V7RoomNight);
    } else {

        doTransition(images.v5.Room2_2);
    }
    if (Question.globalAnswers.v7JennyDateTriedToGoFurther) {

        mc.think(`Talk about blue balls...`);
    } else {
        if (Question.globalAnswers.v7JennyDateKissedHer) {

            mc.think(`I wonder if I should've tried touching her...`);
            mc.think(`I don't think she's that kind of girl.`);
        } else {
            mc.think(`I wonder if I should've tried kissing her...`);

        }
        mc.think(`Anyway, that's in the past now.`);
    }

    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        return jump(V7VanessaCoffeeNightBefore, "V7VanessaCoffeeNightBefore");

    }
    return jump(V7EndDay1, "V7EndDay1");
};
export const V7VanessaCoffeeNightBefore = async (): Promise<any> => {
    doTransition(images.v7.V7RoomNight);

    if (!Game.seenScenarios.includes(`V7_JennyJoeRivalBarBefore`) && mc.properties.joeStatus === "enemy") {

        return jump(V7_JennyJoeRivalBarBefore, "V7_JennyJoeRivalBarBefore");
    }



    if (Game.seenScenarios.includes(`V7_JennyJoeRivalBarBefore`)) {
        if (Question.globalAnswers.v7JoeRivalOfferJennyRide) {
            mc.think(`Sweet! Who'd believe I'll get a number out of that.`);
        } else {
            mc.think(`Joey got totally busted...`);
        }

    }

    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {
        return jump(V7VanessaCoffeeNight, "V7VanessaCoffeeNight");
    }
    if (mc.properties.v7WentWithJennyDate) {
        mc.think(`Holy shit I almost forgot that Vanessa is waiting for me at the coffee shop.\n I better go quick!`);
    } else {
        doTransition(images.v7.V7RoomNight);
        if (Game.seenScenarios.includes(`V7_JennyJoeRivalBarBefore`)) {
            mc.think(`I should meet Vanessa at the coffee shop now, I wonder if she'll stay focused after what happened with Joey.`);

        } else {

            mc.think(`It's time to head to the coffee shop.`);
        }
    }

    return jump(V7VanessaCoffeeNight, "V7VanessaCoffeeNight");
};
export const V7VanessaCoffeeNightAfter = async (): Promise<any> => {
    doTransition(images.v5.Room2_2);

    return jump(V7EndDay1, "V7EndDay1");
};
export const V7_JennyJoeRivalBarBefore = async (): Promise<any> => {
    return jump(V7_JennyJoeRivalBar, "V7_JennyJoeRivalBar");
};
export const V7_JennyJoeRivalBarAfter = async (): Promise<any> => {
    return jump(V7VanessaCoffeeNightBefore, "V7VanessaCoffeeNightBefore");
};
export const V7EndDay1 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Room2_2);
    if (Game.seenScenarios.includes(`V7VanessaCoffeeNightAfter`) && !Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {
        mc.think(`What the fuck? Does she expect me to eat her pussy every time she needs to think?`);
        mc.think(`I wonder if we'll be able to find that dude's grand-daughter...`);
        mc.think(`I honestly have no idea what we are going to find... This might be a dangerous road we are heading down.`);
        mc.think(`And all of this for a fucking barista job...`);
        mc.think(`Around Vanessa everything seems illogical.`);
    }

    return jump(V7EndDay1After, "V7EndDay1After");



};
export const V7EndDay1After = async (): Promise<any> => {
    ImageClass.setImage(images.v1.Room2, { duration: 2 });
    mc.think(`Morning.`);
    if (mc.properties.joeStatus !== "enemy") {
        mc.think(`Seems I got a text while sleeping.`);
        await Phone.showMessagesUI({ name: joe.name }, async () => {
            if (mc.properties.v7WentWithJennyDate) {

                if (ann.properties.isCorrupted) {
                    Phone.setMessage({ character: joe.character, text: `Good morning bro! I hope your date with that chick went well 😉\nI didn't know if she went back to your place or anything so when you have the time bring my car over to the gym, I'll be there all afternoon.`, options: { wait: false } });
                    Phone.talk({ character: mc.character, text: "Yep...got to return the car this afternoon.", options: { think: true } });
                } else {

                    Phone.setMessage({ character: joe.character, text: `Good morning bro! I hope your date with that chick went well 😉\nI didn't know if she went back to your place or anything so when you wake up you can bring my car over to the gym, I'll be there all afternoon.`, options: { wait: false } });
                    Phone.talk({ character: mc.character, text: "Shit! I totally forgot about his car!", options: { think: true } });
                }
            } else {
                if (ann.properties.isCorrupted) {
                    Phone.setMessage({ character: joe.character, text: `Good morning bro! When you have the time come meet me at the gym! I'll be there all day.`, options: { wait: false } });

                } else {
                    Phone.setMessage({ character: joe.character, text: `Good morning bro! When you wake up come meet me at the gym!`, options: { wait: false } });
                    Phone.talk({ character: mc.character, text: "I guess I'll go pay him a visit.", options: { think: true } });
                }
            }

            Phone.closeMessagesUI();
        });

        if (ann.properties.isCorrupted && mc.properties.annStatus === "gf") {

            return jump(V7AnnPreAuditionBefore, "V7AnnPreAuditionBefore");
        }

    }

    return jump(V7MCRoomWait2, "V7MCRoomWait2");
};
export const V7MCRoomWait2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7MCRoomMorning2, { duration: 1 });


    await UI.add({
        key: "v7MCroomWait2",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: mc.properties.joeStatus === "enemy" ? "Continue" : "Meet Joey", key: "continue" }
            ]
    });
    if (UI._globalUI.v7MCroomWait2 === "insta") {
        await Insta.open(getInstaData());
    }

    if (UI._globalUI.v7MCroomWait2 === "continue") {
        return jump(V7JoeGymBefore, "V7JoeGymBefore");

    }
    return jump(V7MCRoomWait2, "V7MCRoomWait2");

};



export const V7JoeGymBefore = async (): Promise<any> => {
    if (isJoeEnemy()) {
        await Phone.showMessagesUI({ name: joe.name }, async () => {
            Phone.setMessage({
                character: joe.character, text: `Hey bro...\nListen... Things are getting out of hands I'd like to apologize if I hurt you and would like to clear everything up...
    Can you please meet me at the gym so we could put this behind us?\nI'm also down to meet you at your place if you prefer...\nHope you'd come bro...`, options: { wait: true }


            });
            Phone.talk({ character: joe.character, text: `That's... Surprising.` });
            Phone.talk({ character: joe.character, text: `If I'm honest with myself, I'm the one who started all of that.` });
            if (Question.globalAnswers.v1EnableNTR) {

            } else {
                Phone.talk({ character: joe.character, text: `And he actually didn't do anything wrong.` });

            }
            Phone.talk({ character: joe.character, text: ``, options: { wait: false } });
            await Phone.setQuestion({
                character: mc.character, question: new Question({ text: `Should I meet with him?`, options: { think: true }, key: `v7JoeRivalTextResponse` })
                    .option({ title: `I'm coming`, key: "metJoey" })
                    .option({ title: `Fuck you`, key: "cussHim" })
                    .option({ title: `<Ignore him>`, key: 'ignored' })
            });

            if (Question.globalAnswers.v7JoeRivalTextResponse === "metJoey") {
                Phone.setMessage({ character: mc.character, text: `I'm coming.` });


            } else if (Question.globalAnswers.v7JoeRivalTextResponse === "cussHim") {
                Phone.setMessage({ character: mc.character, text: `Fuck you` });
            }
            Phone.closeMessagesUI();
        });

        if (Question.globalAnswers.v7JoeRivalTextResponse === "ignored" || Question.globalAnswers.v7JoeRivalTextResponse === "cussHim") {
            if (Question.globalAnswers.v7JoeRivalTextResponse === "cussHim") {
                mc.think(`Yeah... Fuck him.`);

            } else {
                mc.think(`I'm not sure I'm ready to talk to him just yet...`);

            }
            return jump(V7PCLadyConvBefore, "V7PCLadyConvBefore");
        }

        mc.think(`So... I guess this is it...`);
        mc.think(`Let's see what he has to say...`);
    }
    return jump(V7JoeGym, "V7JoeGym");
};
export const V7JoeGymAfter = async (): Promise<any> => {
    return jump(V7PCLadyConvBefore, "V7PCLadyConvBefore");
};

export const V7PCLadyConvBefore = async (): Promise<any> => {
    return jump(V7PCLadyConv, "V7PCLadyConv");
};
export const V7PCLadyConvAfter = async (): Promise<any> => {
    return jump(V7VanessaOutsideConvBefore, "V7VanessaOutsideConvBefore");
};

export const V7VanessaOutsideConvBefore = async (): Promise<any> => {
    return jump(V7VanessaOutsideConv, "V7VanessaOutsideConv");
};
export const V7VanessaOutsideConvAfter = async (): Promise<any> => {
    if (isAnnGF() && ann.properties.isCorrupted) {
        return jump(V7ReturningOutfitBefore, "V7ReturningOutfitBefore");
    }
    return jump(V7AnnHouseBefore, "V7AnnHouseBefore");

};
export const V7AnnHouseBefore = async (): Promise<any> => {
    if (isJoeEnemy() && isAnnGF() && !ann.properties.isCorrupted) {
        return Game.showEnding("normal");
    } else {

    }

    return jump(V7AnnHouse, "V7AnnHouse");
};
export const V7AnnHouseAfter = async (): Promise<any> => {
    return jump(V7ReturningOutfitBefore, "V7ReturningOutfitBefore");
};


export const V7AnnPreAuditionBefore = async (): Promise<any> => {
    if (mc.properties.joeStatus !== "enemy") {

    } else {
        ImageClass.setImage(images.v1.Room2, { duration: 2, wait: 2, hideText: true });

    }
    mc.think(`Ann said she'd be here first thing in the morning.`);
    mc.think(`I should help her with the audition... I'm curious how this will turn out.`);


    return jump(V7AnnPreAudition, "V7AnnPreAudition");
};

export const V7AnnPreAuditionAfter = async (): Promise<any> => {


    return jump(V7AnnAuditionBefore, "V7AnnAuditionBefore");
};

export const V7AnnAuditionBefore = async (): Promise<any> => {
    return jump(V7AnnAudition, "V7AnnAudition");
};

export const V7AnnAuditionAfter = async (): Promise<any> => {

    if (Game.seenScenarios.includes(`V7AnnAudition5Accepted`)) {

        return jump(V7AnnDirectorHotelBefore, "V7AnnDirectorHotelBefore");
    } else {

    }
    if (mc.properties.joeStatus !== "enemy") {
        ImageClass.setImage(images.v7.AnnMCDirectorHotel_11_Empty, { duration: 1.5, wait: 1.5, hideText: true });
        if (mc.properties.v7WentWithJennyDate) {

            mc.think(`Shit, I almost forgot, I need to return Joey's car.`);
        } else {
            mc.think(`Now is a perfect time to meet with Joey.`);

        }
        return jump(V7JoeGymBefore, "V7JoeGymBefore");
    }

    return jump(V7EndDay, "V7EndDay");
};


export const V7AnnDirectorHotelBefore = async (): Promise<any> => {


    return jump(V7AnnDirectorHotel, "V7AnnDirectorHotel");
};

export const V7AnnDirectorHotelAfter = async (): Promise<any> => {
    if (mc.properties.joeStatus !== "enemy") {
        ImageClass.setImage(images.v7.AnnMCDirectorHotel_11_Empty, { duration: 1.5, wait: 1.5, hideText: true });
        if (mc.properties.v7WentWithJennyDate) {

            mc.think(`Shit, I almost forgot, I need to return Joey's car.`);
        } else {
            mc.think(`Now is a perfect time to meet with Joey.`);

        }
        return jump(V7JoeGymBefore, "V7JoeGymBefore");
    }
    return jump(V7EndDay, "V7EndDay");
};

export const V7AlexAnnMCAfterBefore = async (): Promise<any> => {
    doTransition(images.v7.V7MCRoomMorning2);
   
    doPhoneRing();
    ImageClass.setImage(images.v7.V7MCRoomMorning2OnPhone);
    mc.talk(`Hello?`, { method: "On Phone" });
    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v7.V7AlexAnnMC_48);
        ann.talk(`${mc.name}! Hey!`, { method: "Over Phone" });
        mc.talk(`Hey Ann, how you doing?`, { method: "On Phone" });
        ann.talk(`I'm great actually!`, { method: "Over Phone" });
        ImageClass.setImage(images.v7.V7MCRoomMorning2OnPhone);
        if (Game.seenScenarios.includes(`V7AnnPure`)) {
            mc.talk(`That's awesome! Yesterday you seemed a little bummed.`, { method: "On Phone" });
            ann.talk(`Yeah... But I felt better after I got it off my chest!`, { method: "Over Phone" });
            ann.talk(`And honestly I'd rather not talk about that right now...`, { method: "Over Phone" });
        } else {
            if (Game.seenScenarios.includes(`V7AnnAudition5Denied`)) {
                mc.talk(`That's great to hear!`, { method: "On Phone" });
                mc.talk(`I was afraid that the audition result would affect your mood.`, { method: "On Phone" });
                ann.talk(`Nah... It was a long shot anyway.`, { method: "Over Phone" });

            } else if (Game.seenScenarios.includes(`V7AnnAudition5Accepted`)) {
                mc.talk(`Of course you are! You nailed that audition yesterday.`, { method: "On Phone" });
                ann.talk(`Yeah... Hehe!`, { method: "Over Phone" });
            }

        }
        ImageClass.setImage(images.v7.V7AlexAnnMC_48);
        ann.talk(`Anyway! Guess where I am.`, { method: "Over Phone" });
        mc.talk(`Where?`, { method: "On Phone" });
        ann.talk(`At Alex's new place!`, { method: "Over Phone" });


    } else {
        doWaitImageByTime(images.v7.V7AlexAnnMC_50);
        ann.talk(`Hey ${mc.name}...`, { method: "Over Phone" });
        ImageClass.setImage(images.v7.V7MCRoomMorning2OnPhone);
        mc.think(`Ann? Why is she calling me right now?`);
        mc.talk(`Yes?`, { method: "On Phone" });
        doWaitImageByTime(images.v7.V7AlexAnnMC_50);
        if (Question.globalAnswers.v7AnnHouseHateWentInside) {
            ann.talk(`I wanted to apologize if I made you feel uncomfortable...`, { method: "Over Phone" });
        } else {
            ann.talk(`I wanted to apologize for making you wait outside.`, { method: "Over Phone" });
        }
        ann.talk(`Even though things didn't work out between us, I still care for you as a friend.`, { method: "Over Phone" });
        ann.talk(`And I want us to be able to be around each other without it being awkward.`, { method: "Over Phone" });
        ImageClass.setImage(images.v7.V7MCRoomMorning2OnPhone);
        mc.talk(`Thanks Ann. I appreciate that and would like that too.`, { method: "On Phone" });
        ann.talk(`And there is another reason for my call...`, { method: "Over Phone" });
        ann.talk(`I know it might seem out of place but...`, { method: "Over Phone" });
        mc.talk(`I'm listening...`, { method: "On Phone" });
        doWaitImageByTime(images.v7.V7AlexAnnMC_48);
        ann.talk(`I'm currently at a friend's house...`, { method: "Over Phone" });
        ann.talk(`And you know her!`, { method: "Over Phone" });
    }

    doWaitImageByTime(images.v7.V7AlexAnnMC_49);
    alex.talk(`Helloooo!`);
    if (mc.properties.annStatus === "gf") {
        mc.think(`Uh-oh...`);

    } else {
        ImageClass.setImage(images.v7.V7MCRoomMorning2OnPhone);
        mc.think(`Oh shit. I better play nice so Ann will say only good things about me.`);
    }
    if (mc.properties.annStatus === "gf") {
        if (mc.properties.alexKnowsMC) {
            ann.talk(`She told me you helped her with her stuff.`, { method: "Over Phone" });
            ImageClass.setImage(images.v7.V7MCRoomMorning2OnPhone);
            mc.talk(`Yeah, I saw she was moving in. But I didn't know it was her at first till I offered to help.`, { method: "On Phone" });
            ann.talk(`I know! She told me everything.`, { method: "Over Phone" });
            mc.think(`That can't be bad considering how happy she sounds...`);

        } else {
            ann.talk(`I can't believe you both finally met!`, { method: "Over Phone" });
            ImageClass.setImage(images.v7.V7MCRoomMorning2OnPhone);
            mc.think(`And that makes her... Excited?`);
            ann.talk(`I wanted you two to meet, you just beat me to it hehe.`, { method: "Over Phone" });
        }

        ann.talk(`So the reason for my call is...`, { method: "Over Phone" });
    }
    ImageClass.setImage(images.v7.V7AlexAnnMC_48);
    ann.talk(`You know your way around computers right?`, { method: "Over Phone" });
    mc.talk(`We get along pretty good...`, { method: "On Phone" });
    ann.talk(`Alex was checking Insta and suddenly a blue screen appeared.`, { method: "Over Phone" });
    ann.talk(`Any idea what we can do?`, { method: "Over Phone" });
    ImageClass.setImage(images.v7.V7MCRoomMorning2OnPhone);
    mc.talk(`Have you tried turning it off and on again?`, { method: "On Phone" });
    ann.talk(`We did... Like ten times!`, { method: "Over Phone" });
    mc.talk(`Oh... You need to do eleven for this to work.`, { method: "On Phone" });
    ann.talk(`...`, { method: "Over Phone" });
    ann.talk(`That's a joke right?`, { method: "Over Phone" });
    mc.talk(`Yeah...`, { method: "On Phone" });
    mc.talk(`Well, there isn't much I can do over the phone.`, { method: "On Phone" });
    doWaitImageByTime(images.v7.V7AlexAnnMC_50);
    ann.talk(`Oh...`, { method: "Over Phone" });
    mc.talk(`But I can come over and see for myself if you'd like.`, { method: "On Phone" });
    ImageClass.setImage(images.v7.V7AlexAnnMC_48);
    ann.talk(`You would?!`, { method: "Over Phone" });
    mc.talk(`Of course!`, { method: "On Phone" });
    ann.talk(`Great! We are waiting.`, { method: "Over Phone" });

    return jump(V7AlexAnnMC, "V7AlexAnnMC");
};
export const V7AlexAnnMCAfter = async (): Promise<any> => {
    return jump(V7EndDay, "V7EndDay");
};


export const V7EndDay = async (): Promise<any> => {
    if (!Game.seenScenarios.includes(`V7EndDay`)) {
        doTransition(images.v5.Room2_2);
        mc.think(`Another day has ended...`);
        mc.think(`Time to sleep.`);
        await alex.set((properties) => {
            properties.instaFollowing = 153;
            properties.instaFollowers = 486888;
        });
        if (ann.properties.isCorrupted || mc.properties.annStatus === "hate") {
            await ann.set((properties) => {
                properties.instaFollowing = 300;
                properties.instaFollowers = 5581;
            });
        } else {

        }
    } else {

        ImageClass.setImage(images.v5.Room2_2);
    }

    await UI.add({
        key: "v7EndDayButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Continue", key: "continue" }
            ]
    });
    if (UI._globalUI.v7EndDayButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v7EndDayButtons === "continue") {

        if (isJoeEnemy() || isAnnHate()) {
            // return Game.showEnding("normal");
        }
        return jump(V8Start, "V8Start");

    }
    return jump(V7EndDay, "V7EndDay");


};